import { PayloadAction } from '@reduxjs/toolkit';

const reducers = {
  setSelectedBranches(state, action: PayloadAction<number>) {
    state.selected_branches.push(action.payload);
    return state;
  },
  removeSelectedBranches(state, action: PayloadAction<number>) {
    const index = state.selected_branches.indexOf(action.payload);
    state.selected_branches.splice(index, 1);
    return state;
  },
  setSelectedService(state, action: PayloadAction<string>) {
    state.selected_service.push(action.payload);
    return state;
  },
  removeSelectedService(state, action: PayloadAction<string>) {
    const index = state.selected_service.indexOf(action.payload);
    state.selected_service.splice(index, 1);
    return state;
  },
};

export default reducers;
